import type { ReactNode } from 'react';

import { useAuthStore } from '@/stores/auth.store';

interface HydrationGateProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Mitigação do risco "Zustand persist serializa antes do hydrate" (seção 5
 * do briefing): espera o hydrate antes de renderizar o tree. Sem isso, a
 * primeira renderização ocorre com `usuario: null`, o `<PrivateRoute>`
 * dispara redirect, e quando o storage rehidrata o store atualiza mas a
 * URL já mudou — flash de "não logado". (P1-Auth: o flag a observar
 * hoje é `usuario`; antes era `accessToken`.)
 */
export function HydrationGate({ children, fallback }: HydrationGateProps) {
  const hasHydrated = useAuthStore((s) => s._hasHydrated);
  if (!hasHydrated) {
    return (
      <>
        {fallback ?? (
          <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
            Carregando…
          </div>
        )}
      </>
    );
  }
  return <>{children}</>;
}
